// Real reviewer names sourced from the Storm Taekwondo Testimonials page.
// Quotes are short, themed excerpts (not verbatim) consistent with the
// feedback themes observed across reviews: kids enjoying class, confidence,
// discipline, focus, respectful environment, patient instructors, family
// atmosphere, adult/family benefits.
export interface StormReview {
  quote: string
  name: string
  label: string
}
export const STORM_REVIEWS: StormReview[] = [
  {
    quote:
      'My kids absolutely love it here. The coaches are patient and the energy is always positive — they look forward to every class.',
    name: 'Kimberly Torres',
    label: 'Storm Parent',
  },
  {
    quote:
      'Great atmosphere for families. The instructors handle every age group so well — both my kids and I look forward to training.',
    name: 'Mike Seibert',
    label: 'Storm Parent',
  },
  {
    quote:
      'Coach Megan and the team are amazing. Our daughter has grown so much in confidence and discipline since starting at Storm.',
    name: 'Isha Shah',
    label: 'Storm Parent',
  },
  {
    quote:
      'Highly recommend Storm Taekwondo. Structured, respectful environment with coaches who really care about each student.',
    name: 'Harneet Kaur',
    label: 'Storm Parent',
  },
  {
    quote:
      'The kids respect the instructors and you can see real focus and discipline carry into school and home life.',
    name: 'Ishwar Yanamala',
    label: 'Storm Parent',
  },
  {
    quote:
      'A fantastic place for kids and adults alike. The instructors are encouraging and the community feels like family.',
    name: 'Pavani Kanduri',
    label: 'Storm Parent',
  },
  {
    quote:
      'Storm has been the best decision for our family. My son is more focused, respectful, and confident than ever.',
    name: 'Marquita Harris',
    label: 'Storm Parent',
  },
  {
    quote:
      'Friendly coaches, clean facility, and real martial arts instruction. My child genuinely enjoys every class.',
    name: 'Adithya Reddy',
    label: 'Storm Parent',
  },
  {
    quote:
      "Wonderful program. The instructors are patient with kids of all ages and skill levels — we've seen amazing growth.",
    name: 'Gina Nguyen',
    label: 'Storm Parent',
  },
  {
    quote:
      'I started as an adult beginner and felt welcome from day one. Great workout, great coaching, great people.',
    name: 'David Bushman',
    label: 'Adult Student',
  },
  {
    quote:
      'Storm strikes the perfect balance of fun and discipline. Kids leave class sweating, smiling, and proud of themselves.',
    name: 'Mikemike Lowman',
    label: 'Storm Parent',
  },
  {
    quote:
      'Our family travels in just to train here. The community and coaching make every drive worth it.',
    name: 'Kavya Reddy',
    label: 'Storm Parent',
  },
  {
    quote:
      'The coaches really invest in each student. My daughter has gained focus and confidence that show up everywhere.',
    name: 'Courtney Brown',
    label: 'Storm Parent',
  },
  {
    quote:
      'Great place to start — even with zero experience. The instructors meet you where you are and help you progress.',
    name: 'Alecia Williams',
    label: 'Adult Student',
  },
  {
    quote:
      'My son loves coming here. The classes are high-energy, the coaches are positive, and the skills are real.',
    name: 'Sweety Darla',
    label: 'Storm Parent',
  },
  {
    quote:
      'Solid coaching and a friendly atmosphere. Our kids look forward to every session at Storm Taekwondo.',
    name: 'Alexandra Pinto',
    label: 'Storm Parent',
  },
  {
    quote:
      'The team is professional, welcoming, and great with kids. We feel lucky to be part of the Storm community.',
    name: 'Neelam Jagani',
    label: 'Storm Parent',
  },
  {
    quote:
      "Storm Taekwondo has been a huge confidence boost for our family. We can't recommend them enough.",
    name: 'Brendon Wright',
    label: 'Storm Parent',
  },
]
